import { render } from "./SubscriptionItem.vue?vue&type=template&id=281c854e&scoped=true"
import script from "./SubscriptionItem.vue?vue&type=script&lang=js"
export * from "./SubscriptionItem.vue?vue&type=script&lang=js"

import "./SubscriptionItem.vue?vue&type=style&index=0&id=281c854e&scoped=true&lang=css"

import exportComponent from "D:\\PROJET WEB\\carpoolear\\carpoolear_frontend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-281c854e"]])

export default __exports__